import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export let disableScroll = () => {
    let body = document.querySelector('#targetElementId');
    disableBodyScroll(body);
}

export let reinitScroll = () => {
    clearAllBodyScrollLocks()
}